<gp-modal gp-modal="blockingErrorModal" #blockingErrorModal [closable]="true">
  <div class="gp-modal-title">
    {{selectedTranslateKey.title | translate}}
  </div>
  <form novalidate class="gp-modal-body clearfix">
    <div class="alert alert-danger" role="alert">
      <h3 class="h6 alert-heading">
        {{selectedTranslateKey.text | translate}}
      </h3>

      <ul class="errors-list">
        <ng-container *ngFor="let tab of sortedBlockingErrors | keyvalue">
          <li *ngFor="let groupZone of tab.value | keyvalue" class="errors-list-item">
            <span class="error-infos">
            {{'FORM_GENERATOR.tab' | translate}}
              <i>"{{tab.key | translate}}"</i> /
              {{'FORM_GENERATOR.groupZone' | translate}}
              <i>"{{groupZone.key | translate}}"</i>&nbsp;:
            </span>
            <ul class="errors-list-lvl-2" *ngFor="let error of groupZone.value">
              <li class="errors-list-item-lvl-2">
                <span class="error-message">
                  <ng-container *ngIf="error.zone; else defaultTemplate">
                    {{'FORM_GENERATOR.zone' | translate}} <i>"{{ error.zone | translate }}"</i>&nbsp;:
                    {{ 'FORMS.VALIDATORS.' + error.text | translate: error.additionalValues }}
                  </ng-container>
                  <ng-template #defaultTemplate>
                     {{ 'FORM_GENERATOR.ERRORS.' + error.text | translate: error.additionalValues }}
                  </ng-template>
                </span>
              </li>
            </ul>
          </li>
        </ng-container>
      </ul>
    </div>
    <p class="error-correct">
      {{selectedTranslateKey.correct | translate}}
    </p>
  </form>
  <div class="gp-modal-footer">
    <button type="button"
            class="btn btn-dark p-x-md"
            (click)="blockingErrorModal.close($event)">
      {{'FORMS.enclose' | translate}}
    </button>
  </div>
</gp-modal>
